import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=97c37fdc&"
var script = {}
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=97c37fdc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports